import { render, staticRenderFns } from "./OvertimeIndex.vue?vue&type=template&id=31f58fe7&scoped=true"
import script from "./OvertimeIndex.vue?vue&type=script&lang=js"
export * from "./OvertimeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f58fe7",
  null
  
)

export default component.exports